<template>
  <div class="search-actions">
    <template v-if="isVisible">
      <div class="search-actions__left">
        <p class="search-actions__text" :style="{ color: this.theme.text }">
          <span class="search-actions__text__bold">Search results for</span> {{ searchTerm }}
        </p>
      </div>
      <div class="search-actions__right">
        <button v-on:click="handleClearSearch" :style="{ color: this.theme.text }">Clear Search</button>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'search-actions-bar',
  props: {
    theme: {
      type: Object,
      validator(value) {
        return ['light', 'dark', 'custom'].includes(value.type);
      },
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    searchTerm: {
      type: String,
      default: undefined,
    },
    handleClearSearch: {
      type: Function,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.search-actions {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  height: 18px;
  flex-wrap: nowrap;
  &__text {
    font-weight: 400;
    &__bold {
      font-weight: 600;
    }
  }
  &__left {
    min-width: 0;
    .search-actions__text {
      max-width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
    }
  }
  &__right {
    flex: 0 0 auto;
    button {
      border: none;
      background: none;
      color: #532AA2;
      font-size: 16px;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// SearchActionsBar.vue?6af012a4